import { render } from "./usp-card.vue?vue&type=template&id=7a9a2cb6"
import script from "./usp-card.vue?vue&type=script&lang=js"
export * from "./usp-card.vue?vue&type=script&lang=js"

import "./usp-card.vue?vue&type=style&index=0&id=7a9a2cb6&lang=scss"

import exportComponent from "/buddy/dormify/node_modules/@we-make-websites/basis/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__